import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_ENABLE_BRAND_HOVER_CARD_250121 } from "@faire/retailer-settings/FE_ENABLE_BRAND_HOVER_CARD_250121";

export const useSettingEnableBrandHoverCard = (): boolean =>
  useSetting(FE_ENABLE_BRAND_HOVER_CARD_250121);

export const useAssignSettingEnableBrandHoverCard = () =>
  useAssignSetting(FE_ENABLE_BRAND_HOVER_CARD_250121);
